import { render } from "./AssignmentForm.vue?vue&type=template&id=38e166d5"
import script from "./AssignmentForm.vue?vue&type=script&lang=js"
export * from "./AssignmentForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__